import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../api/api";

const font = "Montserrat, sans-serif";

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate       = useNavigate();
  const [status, setStatus]   = useState("loading");
  const [message, setMessage] = useState("");

  const mpStatus          = searchParams.get("status");
  const paymentId         = searchParams.get("payment_id");
  const externalReference = searchParams.get("external_reference");

  useEffect(() => {
    if (mpStatus === "success" || mpStatus === "approved") {
      setStatus("success");
      setMessage("¡Tu pago fue procesado con éxito!");
    } else if (mpStatus === "pending") {
      setStatus("pending");
      setMessage("Tu pago está siendo procesado. Te avisaremos cuando se confirme.");
    } else if (mpStatus === "failure") {
      setStatus("failure");
      setMessage("Hubo un problema con el pago. Podés intentarlo de nuevo.");
    } else {
      setStatus("unknown");
      setMessage("Estamos verificando el estado de tu pago.");
    }
  }, [mpStatus]);

  const isSuccess = status === "success";
  const isPending = status === "pending";
  const isFailure = status === "failure";

  const iconMap = {
    success: { bg: "rgba(27,127,78,0.1)",   color: "#1b7f4e", icon: "✓" },
    pending: { bg: "rgba(176,106,0,0.1)",   color: "#b06a00", icon: "⏳" },
    failure: { bg: "rgba(192,57,43,0.08)",  color: "#c0392b", icon: "✕" },
    unknown: { bg: "rgba(22,50,68,0.08)",   color: "#163244", icon: "?" },
    loading: { bg: "rgba(22,50,68,0.05)",   color: "#7a93a4", icon: "…" },
  };

  const current = iconMap[status] || iconMap.unknown;

  return (
    <div style={{
      minHeight: "100vh", background: "#f5f7fa",
      fontFamily: font, display: "flex",
      alignItems: "center", justifyContent: "center", padding: 24,
    }}>
      <div style={{
        background: "#fff", borderRadius: 20, padding: "48px 36px",
        width: "min(480px, 100%)", textAlign: "center",
        boxShadow: "0 8px 40px rgba(22,50,68,0.1)",
        border: "1px solid rgba(0,0,0,0.06)",
      }}>

        {/* Ícono */}
        <div style={{
          width: 80, height: 80, borderRadius: "50%",
          background: current.bg, margin: "0 auto 24px",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 36, color: current.color, fontWeight: 800,
        }}>
          {status === "loading"
            ? <span style={{ width: 32, height: 32, border: "3px solid #dce5ec", borderTopColor: "#163244", borderRadius: "50%", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
            : current.icon
          }
        </div>

        {/* Título */}
        <h1 style={{ margin: "0 0 10px", fontSize: 22, fontWeight: 800, color: "#163244" }}>
          {isSuccess ? "¡Pago confirmado!" : isPending ? "Pago en proceso" : isFailure ? "Pago no procesado" : "Verificando pago..."}
        </h1>

        {/* Mensaje */}
        <p style={{ margin: "0 0 28px", color: "#7a93a4", fontSize: 14, lineHeight: 1.65 }}>
          {message}
        </p>

        {/* Detalle MP */}
        {paymentId && (
          <div style={{
            background: "#f8fafb", borderRadius: 10, padding: "12px 16px",
            marginBottom: 28, fontSize: 12, color: "#7a93a4",
            border: "1px solid rgba(0,0,0,0.06)",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
              <span>ID de pago</span>
              <span style={{ fontWeight: 600, color: "#163244" }}>{paymentId}</span>
            </div>
            {externalReference && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Referencia</span>
                <span style={{ fontWeight: 600, color: "#163244" }}>#{externalReference}</span>
              </div>
            )}
          </div>
        )}

        {/* Acciones */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {(isSuccess || isPending) && (
            <button onClick={() => navigate("/mis-solicitudes")} style={{
              width: "100%", padding: "14px", borderRadius: 50, border: "none",
              background: "#163244", color: "#fff",
              fontFamily: font, fontWeight: 700, fontSize: 14, cursor: "pointer",
            }}>
              Ver mis solicitudes
            </button>
          )}

          {isFailure && (
            <>
              <button onClick={() => navigate(-1)} style={{
                width: "100%", padding: "14px", borderRadius: 50, border: "none",
                background: "#E7A432", color: "#163244",
                fontFamily: font, fontWeight: 700, fontSize: 14, cursor: "pointer",
              }}>
                Intentar de nuevo
              </button>
              <button onClick={() => navigate("/mis-solicitudes")} style={{
                width: "100%", padding: "13px", borderRadius: 50,
                border: "1.5px solid rgba(22,50,68,0.2)", background: "transparent",
                color: "#163244", fontFamily: font, fontWeight: 600, fontSize: 14, cursor: "pointer",
              }}>
                Volver a mis solicitudes
              </button>
            </>
          )}

          {status === "unknown" && (
            <button onClick={() => navigate("/mis-solicitudes")} style={{
              width: "100%", padding: "14px", borderRadius: 50, border: "none",
              background: "#163244", color: "#fff",
              fontFamily: font, fontWeight: 700, fontSize: 14, cursor: "pointer",
            }}>
              Ver mis solicitudes
            </button>
          )}
        </div>

        {/* MP badge */}
        <div style={{ marginTop: 24, fontSize: 11, color: "#aab8c2", display: "flex", alignItems: "center", justifyContent: "center", gap: 5 }}>
          🔒 Pago procesado por Mercado Pago
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
